import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface SupportIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Support icon using SF Pro font symbol (􀁝)
 *
 * This icon represents help/support functionality in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <SupportIcon />
 * <SupportIcon size={16} weight="semibold" />
 * ```
 */
export const SupportIcon = React.forwardRef<HTMLSpanElement, SupportIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀁝" {...props} />
  }
)

SupportIcon.displayName = "SupportIcon"